// extracted by mini-css-extract-plugin
module.exports = {"full":"EntryTitle_full__hxkD_","h1":"EntryTitle_h1__HaZ5m","h2":"EntryTitle_h2__fhzfT","h3":"EntryTitle_h3__5JlpM","h4":"EntryTitle_h4__DPrx7"};